/*eslint-disable*/
import React from "react";
import { Helmet } from "react-helmet-async";
import { makeStyles } from "@material-ui/core/styles";
import { FaAdn, FaHome } from "react-icons/fa";
import Header from "components/Header/Header.js";
import HeaderLinks from "components/Header/HeaderLinks.js";
import Parallax from "components/Parallax/Parallax.js";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Button from "components/CustomButtons/Button.js";
import OmegaService from "./Section/OmegaService.js";
import OmegaProject from "./Section/OmegaProject.js";
import OmegaBlog from "./Section/OmegaBlog.js";
import OmegaContact from "./Section/OmegaContact.js";
import OmegaFooter from "./Section/OmegaFooter.js";

import omegaBanglePage from "assets/jss/material-kit-pro-react/views/blogPostPageStyle.js";

const useStyles = makeStyles(omegaBanglePage);

export default function OmegaBanglePage() {
  React.useEffect(() => {
    window.scrollTo(0, 0);
    document.body.scrollTop = 0;
  });
  const classes = useStyles();
  const activeSession = sessionStorage.getItem("sessionData");

  const currentUrl = "https://omegabangles.com/";
  const seoTitle =
    "OMEGA BANGLES | Imitation Jewellery Manufacturer & Exporter in India";
  const seoDescription =
    "OMEGA BANGLES is a leading imitation jewellery manufacturer and exporter in India, offering stylish bangles, fashion jewellery, and wholesale designs for every occasion.";
  const seoKeywords =
    "OMEGA BANGLES is a leading imitation jewellery manufacturer and exporter based in Malad, Mumbai, India, offering stylish bangles in sizes such as 1mm, 2mm, 3mm, 4mm, 5mm, 5/2.5mm, 6mm, 6/3mm, 7mm, 7/3.5mm, 8mm, 8/4mm, 9mm, 9/4.5mm, 10mm, 10/5mm, 11mm, 11/5.5mm, 12mm, 12/6mm, 13mm, 13/6.5mm, 14mm, 14/7mm, 15mm, 15/7.5mm, 16mm, 16/8mm, 17mm, 17/8.5mm, 18mm, 18/9mm, 19mm, 19/9.5mm, 20mm, 20/10mm, and 25mm, including gold-plated items such as micro gold plating, tri-colour plating, 7 semanario sets, 3-tone plating, rose gold plating, rhodium plating, and silver plating. We also offer gold-plated meenakari bangles, 2-tone bangles, new Mexican bangles, gold-plated/oro laminado products, hoop earrings (round, big, and modern styles), 3-tone plated bangles, 3-tone U earrings, women’s earrings, animal-designed bangles, kids’ baby 6mm tri-colour bangles, Seven Day (Semanario) bangle bracelets, Mexican 14K gold bangles, three-tone bangles, dual-tone dolphin bypass bangles, dual-tone bangles, fashion jewellery, and wholesale designs for every occasion.";
  const ogImage =
    "https://inshabangles.com/imgstore/original_logo/IndianBanglesImgLogo.png";

  const organizationSchema = {
    "@context": "https://schema.org",
    "@type": "Organization",
    name: "OMEGA BANGLES",
    url: "https://omegabangles.com",
    logo: "https://inshabangles.com/imgstore/original_logo/IndianBanglesImgLogo.png",
    sameAs: ["https://omegabangles.com"],
  };

  return (
    <div>
      <Helmet>
        <html lang="en" />
        <title>{seoTitle}</title>
        <meta name="description" content={seoDescription} />
        <meta name="keywords" content={seoKeywords} />
        <meta name="robots" content="index, follow" />
        <link rel="canonical" href={currentUrl} />

        <meta property="og:type" content="website" />
        <meta property="og:site_name" content="OMEGA BANGLES" />
        <meta property="og:title" content={seoTitle} />
        <meta property="og:description" content={seoDescription} />
        <meta property="og:url" content={currentUrl} />
        <meta property="og:image" content={ogImage} />

        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={seoTitle} />
        <meta name="twitter:description" content={seoDescription} />
        <meta name="twitter:image" content={ogImage} />

        <script type="application/ld+json">
          {JSON.stringify(organizationSchema)}
        </script>
      </Helmet>
      <Header
        // brand={<h4><FaHome /> Omega Bangles</h4>}
        brand="Home"
        links={<HeaderLinks dropdownHoverColor="warning" />}
        fixed
        color="transparent"
        changeColorOnScroll={{
          height: 300,
          color: "warning",
        }}
      />
      <Parallax image={require("assets/img/bg5.jpg").default} filter="dark">
        <div className={classes.container}>
          <GridContainer justify="center">
            <GridItem md={8} className={classes.textCenter}>
              <h1 className={classes.title}>Omega Bangles</h1>
              <h4 className={classes.subtitle}>
                Bangles from us means bangles forever
              </h4>
              <br />
              {activeSession ? (
                ""
              ) : (
                <div>
                  <Button color="warning" round href="/omega-register">
                    sign up
                  </Button>{" "}
                  <Button color="warning" round href="/omega-login">
                    log in
                  </Button>
                </div>
              )}
            </GridItem>
          </GridContainer>
        </div>
      </Parallax>
      <div className={classes.main}>
        <div className={classes.container}>
          <OmegaService />
          <OmegaProject />
        </div>
      </div>
      <OmegaBlog />
      <OmegaContact />
      <OmegaFooter />
    </div>
  );
}
